<template>
	<div class="pa-2">
		<!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			:module="'positions/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="fetchAllPosition()">
			هل أنت متأكد من أنك تريد المسمى الوظيفي  ؟
		</v-delete-dialog>
		<v-row align="center" dense class="mb-3">
			<v-col lg="3" md="4" sm="6" cols="12">
				<v-autocomplete
					v-model="jobPositionSearchId"
					:label="$t('inputs.employee-position')"
					:items="positionItems"
					item-value="id"
					:item-text="item => `${item.no} - ${item.name}`"
					outlined
					dense
					clearable
					hide-details
				/>
			</v-col>
			<v-spacer></v-spacer>
			<v-col v-if="0" cols="auto">
				<v-btn
					@click="addWorkPositionDialog = true"
					small
					dark
					depressed
					color="alt">
					أماكن العمل
				</v-btn>
			</v-col>
			<v-col cols="auto">
				<v-btn
					@click="addPositionDialog = true"
					small
					color="primary">
					<v-icon left> $add </v-icon>
					{{ $T('add') }}
				</v-btn>
			</v-col>
		</v-row>
		<bee-handy-table
			:headers="[
				{ text: '#', name: 'no', value: 'no', width: 40 },
				{ text: $t('headers.position-name'), name: 'name', value: 'name' },
				{ text: '', name: 'actions', value: 'actions' },
			]"
			:items="
				loading
					? []
					: positionItems.filter(c => jobPositionSearchId ? c.id === jobPositionSearchId : true)
			"
			:data-table-props="{ disableSort: true }"
			:loading="loading"
			elevation="3"
			dense
			zebra
			fixed-header
			:items-per-page="-1"
			:height="$vuetify.breakpoint.height - 130"
			hide-default-footer
		>
			<template v-slot:item.actions="{ item }">
				<div class="d-flex justify-end">
                    <tooltip :text="$T('tooltips.edit')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; addPositionDialog = true"
                            >
                            <v-icon
                                size="20"
                                color="edit-color">
                                $edit
                            </v-icon>
                        </v-btn>
                    </tooltip>

                    <tooltip :text="$T('tooltips.delete')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; deleteDialog = true"
                            >
                            <v-icon
                                size="20"
                                color="alert-color  ">
                                $delete
                            </v-icon>
                        </v-btn>
                    </tooltip>
                </div>
			</template>
		</bee-handy-table>

		<v-dialog
			v-model="addPositionDialog"
			max-width="400px"
			transition="dialog-transition">
			<v-card>
				<v-card-title primary-title>
					{{ $T('addPosition.title') }}
					<v-spacer></v-spacer>
					<v-btn
						@click="addPositionDialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="12">
							<v-text-field
								v-model="addPositionName"
								outlined
								dense
								:label="$T('addPosition.name')"
								hide-details></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="align-center">
					<v-spacer></v-spacer>
					<v-btn
						color="secondary"
						:disabled="loadingAdding || !addPositionName"
						:loading="loadingAdding"
						@click="addPosition">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="addWorkPositionDialog"
			:max-width="500"
			transition="dialog-transition">
			<b-add-dialog
				:headers="workPositionHeaders"
				fetch-store="positions/fetchAllWorkPositions"
				add-store="positions/addWorkPositionType"
				@close="addWorkPositionDialog = false"
				@done="addWorkPositionDialog = false"></b-add-dialog>
		</v-dialog>
	</div>
</template>

<script>
import BAddDialog from '@/components/forms/BAddDialog.vue';

export default {
	name: 'AddJobPosition',

	components: { BAddDialog },

	watch: {
		addPositionDialog(val) {
			if(val && this.itemId !== null) {
				this.addPositionName = this.positionItems.find(c => c.id === this.itemId)?.name
			} else {
				this.itemId = null
				this.addPositionName = null
			}
		}
	},

	data() {
		return {
			loadingAdding: false,
			loading: false,

			jobPositionSearchId: null,

			addPositionDialog: false,
			addPositionName: null,

			addWorkPositionDialog: false,

			positionItems: [],

			workPositionHeaders: [
				{
					text: 'الاسم',
					name: 'name',
					value: 'name',
					storeName: 'name',
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 20,
					noInput: true,
					sortable: false,
				},
			],

			itemId: null,
			deleteDialog: false
		};
	},

	methods: {
		addPosition() {
			this.loadingAdding = true;
			const actionName = this.itemId ? 'updatePosition' : 'addPosition'
			this.$store
				.dispatch(`positions/${actionName}`, { name: this.addPositionName, id: this.itemId ? this.itemId : null })
				.then((res) => {
					this.$eventBus.$emit('show-snackbar', this.itemId === null ? this.$T('messages.add-done') : this.$T('messages.edit-done') , { done: true });
					this.fetchAllPosition();
					this.addPositionDialog = false;
				})
				.catch(() => {
					this.$eventBus.$emit('show-snackbar', this.$T('messages.add-fail'), { error: true });
				})
				.finally(() => {
					this.loadingAdding = false;
				});
		},
		fetchAllPosition() {
			this.loading = true;
			this.$store
				.dispatch('filters/fetchJobDescriptions')
				.then((res) => {
					this.positionItems = res.map((c, i) => ({ no: i + 1, ...c }));
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},

	mounted() {
		this.fetchAllPosition();
	},
};
</script>
